export default {
	namespaced: true,
	state: {
		searchString: null,
	},
	mutations: {},
	actions: {},
	getters: {},
};
